(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusControllers')
        .controller('InitiativeUpdateStatusOwnersListController', Controller);

    Controller.$inject = ['$scope', '$filter', '$state', 'topBarService', 'planLookups', 'owners', 'businessPlanningService'];

    function Controller($scope, $filter, $state, topBarService, planLookups, owners, businessPlanningService) {
        topBarService.setTitleAndIcon('Business Planning - Initiative Owners', 'fa fa-compass');

        var ownersByStatus = _.groupBy(owners, 'OwnerStatusValue');

        $scope.allStatus = _.map(planLookups.PlanProgressStatuses, function (status) {
            status.items = ownersByStatus[status.Value];
            status.displayedItems = ownersByStatus[status.Value];
            return status;
        });
        $scope.view = {};

        // Go to Eligible Initiatives
        $scope.goToEligibleInitiatives = function () {
            $state.go('initiativeUpdateStatusEligibleForAssessment');
        };

        // Toggle filter status selection
        $scope.toggleFilterStatusSelection = function (status) {
            $scope.selectedStatus = $scope.selectedStatus === status ? null : status;
        };

        // Is Status Active?
        $scope.isStatusActive = function (status) {
            if (!$scope.selectedStatus) return undefined;
            return $scope.selectedStatus.Value === status.Value;
        };

        // Get Status Css Classes
        $scope.getStatusCssClasses = function (status) {
            var classes = status.CssClasses;

            if ($scope.isStatusActive(status)) {
                classes += ' is-active';
            }

            return classes;
        };

        // Send Reminder
        $scope.sendReminderToOwner = function(owner) {
            if (owner.isSendingInvitation) {
                return;
            }

            owner.isSendingInvitation = true;
            return businessPlanningService
                .sendReminderToOwner(owner)
                .then(function(updatedOwner) {
                    _.assign(owner, updatedOwner);
                })
                .finally(function() {
                    owner.isSendingInvitation = false;
                });
        }

        // Clear Filter
        $scope.clearFilter = function () {
            $scope.selectedStatus = null;
        };

        // Search
        $scope.searchOwners = function (q) {
            var columnsToSearch = ['DisplayName', 'EmployeePositionEN', 'EmployeeDepartmentEN', 'EmployeeEmail'];

            _.forEach($scope.allStatus, function (status) {
                status.displayedItems = $filter('filterBy')(status.items, columnsToSearch, q);
            });
        };
    }
})();